<template>
    <div class="row">
        <div class="col-12 mt-3">
            <!-- display alert message desktop view -->
            <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-3 p-1`" role="alert">
                <i class="fas fa-exclamation-circle"></i> {{ msg }}
            </div>

            <p class="text-cente">
                To complete submitting your order, an account was automatically created for 
                <span v-if="shopperEmail" class="text-dark-green font-weight-bold">{{shopperEmail}}</span>
            </p>
            <p>
                Create a password now to secure it and proceed with submitting your order. Thank you!
            </p>
            <form>
                <div class="row">
                    <div class="col-sm-6 col-12 mt-3">
                        <span class="font-weight-bold">Create password</span>
                        <div class="input-group">
                            <input v-model="password" :type="showPassword ? `text` : `password`" required class="form-control no-lines">
                            <div class="input-group-append">
                                <div @click.prevent="showPasswordFxn" class="input-group-text bg-light font-weight-bold clickable">
                                    <i v-if="showPassword" class="fas fa-eye-slash"></i>
                                    <i v-else class="fas fa-eye"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 col-12 mt-3">
                        <span class="font-weight-bold">Confirm password</span>
                        <div class="input-group">
                            <input v-model="rePassword" :type="showRePassword ? `text` : `password`" required class="form-control no-lines">
                            <div class="input-group-append">
                                <div @click.prevent="showRePasswordFxn" class="input-group-text bg-light font-weight-bold clickable">
                                    <i v-if="showRePassword" class="fas fa-eye-slash"></i>
                                    <i v-else class="fas fa-eye"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- proceed to order button -->
                    <div class="col-12 text-center mt-3">
                        <button 
                            @click.prevent="createPasswordFxn" 
                            v-bind:class="{'disabledClass' : disablePasswordBtn}" 
                            class="btn btn-dark-green form-control">
                            <span v-if="disablePasswordBtn">
                                <i class="fas fa-cog fa-spin"></i> please wait...
                            </span>
                            <span v-else>Complete submitting order</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { webpageTitle } from '@/store/dry'

export default {
    name: "CreatePassword",
    props: {
        shopperConfToken: {
            type: String,
            required: true
        },
        shopperEmail: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            password: '',
            rePassword: '',
            showPassword: false,
            showRePassword: false,
            disablePasswordBtn: false,
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['resetPassword']),
        createPasswordFxn() {
            if(this.password === ''){ this.msg = "Enter a strong password!"; return }
            if(this.password.length < 6){ this.msg = "Strong passwords are more than 5 characters"; return }
            if(this.password !== this.rePassword){ this.msg = "Passwords do not match! Try again"; return }
            
            // first disable the post item button to avoid repeated clicks during slow network
            this.disablePasswordBtn = true

            // proceed with adding password to the newly created users account
            let userObj = {
                email: this.shopperEmail,
                confToken: this.shopperConfToken,
                newPassword: this.password
            }
            this.resetPassword(userObj)
            .then((data) => {
                if(!data.error){
                    this.color = "success"
                    this.password = ""
                    this.rePassword = ""
                    this.displayOrderNumberFxn()
                }
                this.msg = data.msg
            }).catch((e) => {
                this.disablePasswordBtn = false
                this.password = ""
                this.msg = "We are having issues reaching our resoruces at this time. Check back soon."
            })
        },
        showPasswordFxn() {
            this.showPassword = !this.showPassword
        },
        showRePasswordFxn() {
            this.showRePassword = !this.showRePassword
        },
        displayOrderNumberFxn() {
            // turn off the showCreatePassword on OrderConfirmation page to display the order number
            setTimeout(() => {
                this.disablePasswordBtn = false
                this.$emit('emitCreatePasswordFxn', true)
            }, 1000); // simulate ajax request ;)
        }
    },
    created() {
        webpageTitle(`Create password`)
    }
}
</script>
